import { render, staticRenderFns } from "./newviews.vue?vue&type=template&id=19561bf1&scoped=true&"
import script from "./newviews.vue?vue&type=script&lang=js&"
export * from "./newviews.vue?vue&type=script&lang=js&"
import style0 from "./newviews.vue?vue&type=style&index=0&id=19561bf1&scoped=true&lang=scss&"
import style1 from "./newviews.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19561bf1",
  null
  
)

export default component.exports